module.exports = __webpack_public_path__ + "static/12-Mindscape-Garden-0027c2ff2a0e1f1c8f435838f8775a5d.jpg";